<template>
	<div class="mytable-style">
		<vxe-table ref="table"
				   auto-resize
				   show-overflow="tooltip"
				   :data="busProContractCosts"
				   :header-cell-class-name="headerCellClassName"
				   :highlight-current-row="isGl"
				   :highlight-hover-row="isGl">
			<vxe-table-column field="sname"
							  title="信息名称"></vxe-table-column>
			<vxe-table-column field="estimateMoney"
							  title="概算价"></vxe-table-column>
			<vxe-table-column field="controlMoney"
							  title="控制价"></vxe-table-column>
			<vxe-table-column field="biddingMoney"
							  title="中标价"></vxe-table-column>
			<vxe-table-column field="reportMoney"
							  title="报审价"></vxe-table-column>
			<vxe-table-column field="beforeMoney"
							  title="初审价"></vxe-table-column>
			<vxe-table-column field="afterMoney"
							  title="审定价"></vxe-table-column>
		</vxe-table>
	</div>
</template>

<script>
export default {
	name: 'analysis-sheet-info',
	data() {
		return {
			isGl: true, //是否高亮
			busProContractCosts: []
		}
	},
	methods: {
		getVxeTableData() {
			return this.$refs.table.getTableData()
		},
		headerCellClassName({ column, columnIndex }) {
			return 'col-blue'
		}
	}
}
</script>

<style lang="less">
.mytable-style .vxe-header--column.col-blue {
	// background-color: #c9f3ee;
	// color: #666;
	background-color: #0073ab;
	color: #fff;
}

.el-collapse-item__content {
	padding-bottom: 0px;
}
</style>
